<template>
  <div>
    <pbas-data-table
      v-if="planOptions.HasBillingImport"
      ref="table"
      :dataProvider="provider"
      identifier="contributionsTerms"
      @error="error = $event"
      :showSelect="false"
      :rowActions="rowActions"
      :floatActions="floatActions"
    ></pbas-data-table>
    <pbas-data-table
      v-else
      ref="table"
      :dataProvider="provider"
      identifier="contributionsTerms"
      @error="error = $event"
      :showSelect="false"
      :floatActions="floatActions"
    ></pbas-data-table>
    <error-handler :error="error"></error-handler>
    <v-dialog scrollable v-model="dialogs.view" persistent max-width="1200">
      <term-view
        :term="term"
        :employer="employer"
        @close="dialogs.view = false"
      />
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.revise" persistent max-width="1200">
      <material-card
        :title="
          $t('views.contributionsrevisewizard.revise_employer_contributions')
        "
        :color="$vuetify.theme.themes.light.primary"
        icon="mediation"
      >
        <v-card-text>
          <contributions-revise-wizard
            v-if="dialogs.revise"
            ref="revisewizard"
            :term="term"
            @close="dialogs.revise = false"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$refs.revisewizard.dialogs.cancel = true">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.import" persistent max-width="1200">
      <material-card
        :title="$t('views.contributionswizard.import_employer_contributions')"
        :color="$vuetify.theme.themes.light.primary"
        icon="mediation"
      >
        <v-card-text>
          <contributions-wizard
            v-if="dialogs.import"
            ref="wizard"
            :employerId="employer.Id"
            :term="term"
            @close="dialogs.import = false"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$refs.wizard.dialogs.cancel = true">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <!-- <v-dialog scrollable v-model="dialogs.setup" persistent max-width="1200">
      <terms-setup
        :employer="employer"
        @close="
          dialogs.setup = false;
          $refs.table.getDataAsync();
        "
      />
    </v-dialog> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../../components/ErrorHandler";
import { ODataProvider } from "pbas-vue-components";
import { locker } from "../../mixins/locker";
import { planSetter } from "../../mixins/planSetter";
import ContributionTermsHeaders from "../../headers/ContributionTerms";
import TermView from "./TermView";
import TermsSetup from "./TermsSetup";
import ContributionsWizard from "./ContributionsWizard.vue";
import ContributionsReviseWizard from "./ContributionsReviseWizard.vue";

export default {
  name: "contribution-terms-table",
  components: {
    ErrorHandler,
    TermView,
    ContributionsReviseWizard,
    TermsSetup,
    ContributionsWizard,
  },
  mixins: [locker, planSetter],
  props: ["employer"],
  data() {
    return {
      // firstRun: true,
      show: true,
      error: null,
      provider: undefined,
      term: null,
      rowActions: [
        {
          name: "view",
          icon: "visibility",
          title: "globals.view",
          visible: (item) => item.IsCompleted === true,
          handler: (item) => {
            this.term = JSON.parse(JSON.stringify(item));
            this.dialogs.view = true;
          },
        },
        {
          name: "revise",
          icon: "refresh",
          title: "globals.revise",
          visible: (item) => item.IsCompleted === true,
          handler: (item) => {
            this.term = JSON.parse(JSON.stringify(item));
            this.dialogs.revise = true;
          },
        },
        {
          name: "import",
          icon: "insert_drive_file",
          title: "globals.import",
          visible: (item) => item.IsCompleted === false,
          handler: (item) => {
            this.term = JSON.parse(JSON.stringify(item));
            this.dialogs.import = true;
          },
        },
      ],
      floatActions: [
        // {
        //   text: "globals.setup",
        //   color: this.$vuetify.theme.themes.light.success,
        //   name: "setup",
        //   icon: "settings",
        //   visible: () => this.employer.EmployerContributionTerm.IsCustom,
        //   handler: () => {
        //     this.dialogs.setup = true;
        //   },
        // },
      ],
      dialogs: {
        view: false,
        revise: false,
        import: false,
        setup: false,
      },
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("common", {
      selectedPlan: "plan",
    }),
    ...mapGetters("plansMembers", ["planOptions"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.provider = undefined;
        if (this.employer !== null && this.employer !== undefined) {
          // this.loadPlanData();
          this.$nextTick(() => {
            this.loadPlanData();
          });
        }
      },
    },
    employer: {
      handler(v) {
        this.provider = undefined;
        if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
          this.$nextTick(() => {
            this.loadPlanData();
          });
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (
      this.selectedPlan !== null &&
      this.selectedPlan !== undefined &&
      this.employer !== null &&
      this.employer !== undefined
    ) {
      this.loadPlanData();
    }
  },
  methods: {
    async loadPlanData() {
      const url = `plans/${this.selectedPlan.Id}/employers-for-import/${
        this.employer.Id
      }/contribution-terms`;
      let headers = ContributionTermsHeaders;
      this.provider = new ODataProvider(this.$axiosHttp, url, headers);
      // if (this.firstRun) {
      //   this.firstRun = false;
      // } else {
      //   this.$refs.table.getDataAsync();
      // }
    },
  },
};
</script>
